module.exports = __webpack_public_path__ + "img/maintenance.f1f78ed1.png";